/** Mensaje de error legible para el usuario (sin códigos HTTP). */
import { tr } from '@/contexts/LanguageContext';

export const friendlyError = (err, fallback) => {
  if (err?.networkError) return tr("Sin conexión. Revisa tu internet e inténtalo de nuevo.");
  const d = err?.payload?.detail;
  if (typeof d === 'string' && d.trim()) return d;
  if (Array.isArray(d) && d.length) {
    const msgs = d.map((x) => (typeof x?.msg === 'string' ? x.msg.replace(/^Value error,\s*/i, '') : null)).filter(Boolean);
    if (msgs.length) return msgs[0];
  }
  if (d && typeof d === 'object' && d.message) return d.message;
  return fallback || tr("Algo salió mal. Inténtalo de nuevo.");
};

export default friendlyError;
